import React from 'react';
import { Box, Grid, SpaceBetween } from '@cloudscape-design/components';
import './header.scss';

interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

/**
 * PageHeader component displays a hero-style header for a landing page.
 *
 * This component uses Cloudscape Design System components to create a
 * structured and visually appealing header section. It includes a welcome
 * message, a main title, a subtitle, and a description.
 *
 * @component
 * @example
 * ```jsx
 * <PageHeader
 *   title="My Application"
 *   subtitle="Powerful and Easy to Use"
 *   description="Welcome to the next generation of web applications."
 * />
 * ```
 */
export const PageHeaderClassic: React.FC<PageHeaderProps> = ({ title, subtitle, description }) => {
  return (
    <div className="landing-header">
      <div className="header-container">
        <Grid
          gridDefinition={[
            {
              colspan: 10,
            },
          ]}
        >
          <SpaceBetween size="s">
            <Box variant="h1" fontSize="display-l" fontWeight="bold">
              {title}
            </Box>
            <Box fontSize="heading-s">{description}</Box>
          </SpaceBetween>
        </Grid>
      </div>
    </div>
  );
};
